import * as React from "react";
import { useRouteError, isRouteErrorResponse } from "react-router-dom";
import { ForbiddenError, FourOhThreePage } from "./FourOhThreePage";
import { FourOhFourPage, NotFoundError } from "./FourOhFourPage";

export const ErrorBoundary: React.FC = () => {
  const error = useRouteError();

  if (error instanceof ForbiddenError) {
    return <FourOhThreePage />;
  }

  if (error instanceof NotFoundError) {
    return <FourOhFourPage />;
  }

  if (
    (isRouteErrorResponse(error) &&
      (error.status === 403 || error.status === 404)) ||
    (error instanceof Response &&
      (error.status === 403 || error.status === 404))
  ) {
    if (error.status === 403) {
      return <FourOhThreePage />;
    }
    if (error.status === 404) {
      return <FourOhFourPage />;
    }
  }

  return (
    <FourOhFourPage />
  );
};

